import { SearchComponent } from "SuperAdmin/Components";
import { getAllRoles } from "SuperAdmin/Services/Role";
import { Button } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "./Components/Table/Table";
import styles from "./RoleList.module.scss";
import { handleAPIResponse } from "SuperAdmin/Utils/HandleAPIResponse";
const RoleList = () => {
  const [data, setData] = useState({ isLoading: true, data: [] });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  const [filters, setFilters] = useState({
    query: "",
    institution_id: null,
    type: 1,
    entity_id: null,
    entity_type: null,
  });
  useEffect(() => {
    setData({ ...data, isLoading: true });
    getAllRoles(pagination.page - 1, pagination.rowsPerPage, filters, (res) => {
      handleAPIResponse(res, () => {
        if (res.data) {
          setData({
            data: res.data.roles,
            isLoading: false,
          });
          setPagination({
            ...pagination,
            totalRows: res.data.total,
          });
        } else {
          setData({ data: [], isLoading: false });
        }
      });
    });
  }, [pagination.page, pagination.rowsPerPage, filters]);
  return (
    <div className={styles["role-list"]}>
      <div className={styles["search-bar"]}>
        <SearchComponent
          placeholder={"Search for role"}
          filters={filters}
          setFilters={setFilters}
          entity={"query"}
        />
        <Link to={"/super-admin/create-role"}>
          <Button type="primary">Create role</Button>
        </Link>
      </div>
      <div className={styles["roles"]}>
        <Table
          data={data}
          pagination={pagination}
          setPagination={setPagination}
          filters={filters}
          setFilters={setFilters}
        />
      </div>
    </div>
  );
};

export default RoleList;
